import EventCard from "@/components/base/EventCard";
import SectionHeading from "@/components/base/SectionHeading";
import { events } from "@/mocks/events";

export default function FeaturedSection() {
  const featured = events.filter((item) => item.featured).slice(0, 4);

  return (
    <section className="w-full" aria-label="年度盘点精选">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="EDITORS' PICKS"
          title="年度盘点精选"
          description="由编辑部从全年事件中挑出的四篇档案，覆盖情感、综艺、影视与商业四条线索，每一篇都附有完整时间线与后续进展。"
          actionLabel="查看全部档案"
          actionTo="/archive"
        />
        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 md:mt-10">
          {featured.map((event) => (
            <EventCard key={event.id} event={event} />
          ))}
        </div>
      </div>
    </section>
  );
}